import moduleCommon from "@/store/common/moduleCommon.js";
import Api from "@/helpers/api.js";
import {Validator} from "vee-validate";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import PopupMap from "@/components/optimization/visit-point/PopupMap.vue";
import {MapFeatures} from "@/plugins/mapFeatures";
import ManageErrorMessages from "@/models/ManageErrorMessages";
import phonesSuccess from "@/assets/images/markers/phones_success.png";
import {en, es} from "vuejs-datepicker/src/locale";
import Datepicker from "vuejs-datepicker";
import DateUtils from "@/helpers/DateUtils.js";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moduleMap from "@/store/map/moduleMap.js";
import Utils from "@/helpers/Utils";
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin.js";
import moment from "moment";

export const resourceCreateMixin = {
	name: "AddResource",
	mixins: [generalPurposeMixin],
	components: {
		vSelect,
		flatPickr,
		Datepicker,
		PopupMap,
		VuePerfectScrollbar,
	},
	props: {
		data: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			activeTab: 0,
			popupMapMounted: false,
			dataCity: null,
			selectedCountry: null,
			selectedDepartment: null,
			departments: [],
			countries: [],
			cities: [],
			showButtonAddCoordinates: true,
			dataGeo: {},
			showPromptField: false,
			showPromptDemand: false,
			showPromptBreak: false,
			showPromptSkill: false,
			propertiesList: [],
			propertiesListDemand: [],
			propertiesListSkill: [],
			propertiesListBreak: [],
			isUpdate: false,
			isUpdateDemand: false,
			isUpdateBreak: false,
			isUpdateSkill: false,
			indexUpdate: null,
			indexUpdateDemand: null,
			indexUpdateBreak: null,
			indexUpdateSkill: null,
			showGeoAgaing: false,
			isDisabled: true,
			isTimeWindow: false,
			validFormTimeWindowComputed: true,
			marker: null,
			manageErrorMessages: new ManageErrorMessages({that: this}),
			geoAlert: false,
			geoAlertAddress: false,
			langHe: es,
			langEn: en,
			isSoftTimeWindow: false,
			isAlertTimeWindow: false,
			isClusteredRoute: true,
			closeInfo: true,
			propertiesListTerritory: [],
			showPromptTerritory: false,
			isUpdateTerritory: false,
			indexUpdateTerritory: null,
			resource: {
				identification: "",
				original_identification: "",
				hours: 0,
				minutes: 0,
				seconds: 0,
				max_travel_duration: "",
				max_travel_distance: "",
				init_depot: "",
				end_depot: "",
				profile: "",
				skill: "",
				additional_info: {},
				strict_territories: false,
				territories: {
					id: "",
					priority: 0,
				},
				clustering: {
					max_distance_to_neighbor: 25,
					max_diameter: 100,
				},
				capacity: {
					name: "",
					amount: "",
				},
				time_window: {
					init_date_window: "",
					end_date_window: "",
					init_hour_window: "",
					end_hour_window: "",
				},
				breaks: {
					init_date_window: "",
					end_date_window: "",
					init_hour_window: "",
					end_hour_window: "",
				},
				min_break_hours: 0,
				min_break_minutes: 0,
				min_break_seconds: 0,
				costs: {
					distance: 0,
					fixed: 0,
					time: 0,
					traveled_hour: 0,
				},
			},
			profileOptions: [
				{
					label: this.$t("Routing.Car"),
					value: "car",
				},
				{
					label: this.$t("Routing.Walking"),
					value: "walk",
				},
				{
					label: this.$t("Routing.Bicycle"),
					value: "bicycle",
				},
				{
					label: this.$t("Routing.Motorcycle"),
					value: "motorcycle",
				},
				{
					label: this.$t("Routing.Truck"),
					value: "truck",
				},
				{
					label: this.$t("Routing.Scooter"),
					value: "scooter",
				},
				{
					label: this.$t("Routing.Bus"),
					value: "bus",
				},
			],
			mapConfig: {
				name: "optimization-map",
				latitude: 4.686699,
				longitude: -74.0837187,
				zoom: "13",
				theme: "uber",
				calledFrom: "DinamicFields",
			},
			formatData: {
				country: "",
				department: "",
				city: "",
				address: "",
				addressOld: "",
				cx: 0,
				cy: 0,
				typeDeposit: "InitDeposit",
			},
			settingsForm: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			configdateTimePicker: {
				enableSeconds: true,
				enableTime: true,
				noCalendar: true,
			},
			property: {
				label: "",
				value: "",
				type: {
					label: "Text",
					value: "text",
				},
			},
			type: [
				{
					label: "Text",
					value: "text",
				},
				{
					label: "Date",
					value: "date",
				},
				{
					label: "Time",
					value: "time",
				},
				{
					label: "Number",
					value: "number",
				},
			],
		};
	},
	computed: {
		countriesOptions() {
			return this.generateOptionSelect(this.$store.state.moduleCommon.countries, "country_name", "country_name");
		},
		validateForm() {
			return !this.errors.any();
		},
		vsPopupTitle() {
			return `${this.$t("Select")} ${this.$t("Routing.Point")}`;
		},
		disabledDatesTo() {
			return {to: new Date(this.resource.time_window.init_date_window)};
		},
		getDateWithoutTime() {
			return (date) => {
				return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
			};
		},
		showErrorSoftWindow() {
			return (generalWindow, fieldTimeWindow, fieldSoftWindow) => {
				const softTimeDate = new Date(generalWindow.soft_time_window[fieldSoftWindow]);
				const generalDate = new Date(generalWindow[fieldTimeWindow]);
				return softTimeDate != "" && fieldTimeWindow === "init_date_window"
					? this.getDateWithoutTime(softTimeDate) < this.getDateWithoutTime(generalDate)
					: this.getDateWithoutTime(softTimeDate) > this.getDateWithoutTime(generalDate);
			};
		},
		showErrorSoftWindowHour() {
			return (generalWindow, fieldGeneralWindow, fieldSoftWindow) => {
				const softTimeDate = generalWindow.soft_time_window[fieldSoftWindow];
				const generalDate = generalWindow[fieldGeneralWindow];
				return (
					softTimeDate !== "" &&
					(fieldGeneralWindow === "init_hour_window"
						? this.stringTimeToDate(softTimeDate) < this.stringTimeToDate(generalDate)
						: this.stringTimeToDate(softTimeDate) > this.stringTimeToDate(generalDate))
				);
			};
		},
		isStartBeforeEnd() {
			return (generalWindow, fieldInit, fieldEnd) => {
				const softTimeDateInit =
					fieldInit === "init_hour"
						? generalWindow.soft_time_window[fieldInit]
						: this.getDateWithoutTime(new Date(generalWindow.soft_time_window[fieldInit]));
				const softTimeDateEnd =
					fieldInit === "init_hour"
						? generalWindow.soft_time_window[fieldEnd]
						: this.getDateWithoutTime(new Date(generalWindow.soft_time_window[fieldEnd]));
				return fieldInit === "init_hour"
					? this.stringTimeToDate(softTimeDateInit) > this.stringTimeToDate(softTimeDateEnd)
					: softTimeDateInit > softTimeDateEnd;
			};
		},
		validFormAdditionalFields() {
			return this.property.label.length > 0 && this.property.value.length > 0;
		},
		validFormDemand() {
			return this.resource.capacity.name.length > 0 && this.resource.capacity.amount.length > 0;
		},
		validFormTerritory() {
			return this.resource.territories.id.length > 0 && this.resource.territories.priority.length > 0;
		},
		validFormSkill() {
			return this.resource.skill.length > 0;
		},
		validFormBreak() {
			return (
				this.resource.breaks.init_date_window !== "" &&
				this.resource.breaks.end_date_window !== "" &&
				this.resource.breaks.init_hour_window !== "" &&
				this.resource.breaks.end_hour_window !== "" &&
				Date.parse(this.resource.breaks.end_date_window) - Date.parse(this.resource.breaks.init_date_window) >=
					0 &&
				!this.errors.has("dataHourInit") &&
				!this.errors.has("dataHourEnd") &&
				!this.errors.has("minBreakDuration")
			);
		},
		validFormTimeWindow: {
			get() {
				this.validFormTimeWindowComputed =
					this.resource.time_window.init_date_window !== "" &&
					this.resource.time_window.end_date_window !== "" &&
					this.resource.time_window.init_hour_window !== "" &&
					this.resource.time_window.end_hour_window !== "" &&
					Date.parse(this.resource.time_window.end_date_window) -
						Date.parse(this.resource.time_window.init_date_window) >=
						0 &&
					!this.errors.has("dataHourInit") &&
					!this.errors.has("dataHourEnd");
				return this.resource.time_window.hasOwnProperty("soft_time_window")
					? this.validFormTimeWindowComputed && this.validFormSoftTimeWindow
					: this.validFormTimeWindowComputed;
			},
			set(val) {
				this.validFormTimeWindowComputed = val;
				return this.validFormTimeWindowComputed;
			},
		},
		validFormSoftTimeWindow() {
			return (
				this.resource.time_window.soft_time_window.init_date !== "" &&
				this.resource.time_window.soft_time_window.end_date !== "" &&
				this.resource.time_window.soft_time_window.init_hour !== "" &&
				this.resource.time_window.soft_time_window.end_hour !== "" &&
				!this.isStartBeforeEnd(this.resource.time_window, "init_date", "end_date") &&
				!this.showErrorSoftWindow(this.resource.time_window, "init_date_window", "init_date") &&
				!this.showErrorSoftWindow(this.resource.time_window, "end_date_window", "end_date") &&
				!this.isStartBeforeEnd(this.resource.time_window, "init_hour", "end_hour") &&
				!this.showErrorSoftWindowHour(this.resource.time_window, "init_hour_window", "init_hour") &&
				!this.showErrorSoftWindowHour(this.resource.time_window, "end_hour_window", "end_hour")
			);
		},
		optimizersList() {
			return this.$store.state.moduleOptimization.listCompanyOptimizers;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		geoCoder() {
			const {country, city, address, department} = this.formatData;
			if (address === null || address === undefined || address === "") {
				this.$vs.notify({
					color: "warning",
					title: this.$t("VisitPoints.MissingAddress.Title"),
					text: this.$t("VisitPoints.MissingAddress.Text"),
				});
				return;
			}
			this.openLoading();
			this.$store
				.dispatch("moduleMap/geocoder", {country, city, address, department})
				.then((res) => {
					this.closeLoading();
					if (res.status !== 200) {
						throw new Error("Not georreferencer address");
					}
					if (res.status === 200 && res.message === "Procesado y no ubicado.") {
						this.$vs.notify({
							color: "warning",
							title: this.$t("VisitPoints.Georeferencer"),
							text: this.$t("VisitPoints.AddressCouldBeNotGeoreferenced"),
						});
						return;
					}

					if (res.status === 200) {
						this.dataGeo = {...res.data};
						this.formatData.cy = parseFloat(this.dataGeo.latitude);
						this.formatData.cx = parseFloat(this.dataGeo.longitude);
						this.formatData.cy.toFixed(8);
						this.formatData.cx.toFixed(8);
						this.geoAlertAddress = false;
						this.showButtonAddCoordinates = true;
						if (this.dataGeo.latitude !== "0" || this.dataGeo.longitude !== "0") {
							this.$vs.notify({
								color: "success",
								title: this.$t("VisitPoints.FindAddress.Title"),
								text: this.$t("VisitPoints.FindAddress.Text"),
							});
							this.showGeoAgaing = true;
							this.map.removeMarker(this.marker);
							this.marker = this.map.addMarkerToMap(this.formatData, {
								icon: phonesSuccess,
								draggable: true,
								infoWindow: {
									content: `
										<div class='flex items-center mt-2'>
											<span class='text-ms'>${formatData.cy}, ${formatData.cx}</span>
										</div>
									`,
								},
								onDragend: (coords) => {
									this.geoReverse({
										cy: coords.lat,
										cx: coords.lng,
									});
								},
							});
							this.isDisabled = true;
						} else {
							this.$vs.notify({
								color: "warning",
								title: this.$t("VisitPoints.ErrorFindAddress.Title"),
								text: this.$t("VisitPoints.ErrorFindAddress.Text"),
							});
						}
					}
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorMessages.processError(err);
					console.error(err);
				});
		},
		geoReverse({cy, cx}) {
			this.openLoading();
			this.isDisabled = true;
			this.$store
				.dispatch("moduleMap/geoinverso", {cy, cx})
				.then((res) => {
					this.closeLoading();
					if (res.data.address1 !== this.formatData.address) {
						this.formatData.cy = cy.toFixed(8);
						this.formatData.cx = cx.toFixed(8);
						this.formatData.address = res.data.address1;
						this.formatData.addressOld = res.data.address1;
						this.selectedCountry = res.data.country_long_name;
						this.selectedDepartment = res.data.department1;
						this.dataCity = res.data.city1;
						this.showButtonAddCoordinates = true;
						this.geoAlertAddress = false;
					}
					if (res.status === 200 && (res.data.status === "C" || res.data.status === "")) {
						this.formatData.cy = 0;
						this.formatData.cx = 0;
						this.$vs.notify({
							color: "warning",
							title: this.$t("VisitPoints.ErrorFindAddress.Title"),
							text:
								this.$t("VisitPoints.ErrorFindAddress.Text") +
								", " +
								this.$t("VisitPoints.ErrorFindCountry.Text"),
							time: 7000,
						});
					}
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorMessages.processError(err);
					console.error(err);
				});
		},
		getInstanceMap(data) {
			const map = data.map;
			this.map = new MapFeatures(map);
			this.marker = data.marker;
		},
		cancelAction() {
			this.formatData.address = this.formatData.addressOld;
			this.showButtonAddCoordinates = true;
			this.isDisabled = true;
			this.geoAlertAddress = false;
		},
		generateOptionSelect(data, propLabel, propValue) {
			if (!Array.isArray(data)) {
				return [];
			}
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		addResource() {
			if (this.showTimeWindowAlert()) return;
			this.$vs.loading();
			this.isAlertTimeWindow = false;
			this.$validator.validateAll("create-resource").then((result) => {
				if (!result) {
					this.showValidationError();
					return;
				}
				const payloadStandardInput = this.buildPayload();
				this.cleanupPayload(payloadStandardInput);
				this.$store.commit("moduleOptimization/SET_VEHICLE_STANDARD_INPUT", [payloadStandardInput]);
				this.$vs.loading.close();
				this.closeSidebarAddResource();
			});
		},
		showTimeWindowAlert() {
			if (!this.validFormTimeWindow && this.isTimeWindow) {
				this.isAlertTimeWindow = true;
				this.$vs.notify({
					color: "warning",
					title: this.$t("MissingFieldTitle"),
					text: `${this.$t("ResourceModule.BasicInfoForm.Messages.AllFieldsRequired")} ${this.$t(
						"TimeWindow.TimeWindow"
					)}`,
				});
				return true;
			}
			return false;
		},
		showValidationError() {
			this.$vs.notify({
				color: "warning",
				title: this.$t("ErrorFields.Title"),
				text: this.$t("ErrorFields.Text"),
			});
			this.$vs.loading.close();
		},
		buildPayload() {
			const coordinatesInitDepot = this.getCoordinates(this.resource.init_depot);
			const endDepot = this.getEndDepotCoordinates(this.resource.end_depot);
			this.formatTimeWindow();
			return {
				identification: this.resource.identification,
				original_identification: this.resource.original_identification,
				profile: this.resource.profile.value,
				max_travel_distance: this.resource.max_travel_distance,
				max_travel_duration: this.formatDuration(),
				init_depot: coordinatesInitDepot,
				end_depot: endDepot,
				costs: Utils.convertItemObjectToNumbers(this.resource.costs),
				skills: this.propertiesListSkill || [],
				capacity: this.propertiesListDemand || [],
				time_window: this.resource.time_window || {},
				breaks: this.processBreaks(),
				additional_info: this.resource.additional_info || {},
				clustering: this.isClusteredRoute ? Utils.convertItemObjectToNumbers(this.resource.clustering) : null,
				territories: {
					strict: this.resource.strict_territories || false,
					items: this.propertiesListTerritory || [],
				},
			};
		},
		processBreaks() {
			return this.propertiesListBreak.map((breakItem) => {
				const processedBreak = {
					init_date_window: DateUtils.toDefaultDateTime(breakItem.init_date_window, "YYYY-MM-DD"),
					end_date_window: DateUtils.toDefaultDateTime(breakItem.end_date_window, "YYYY-MM-DD"),
					init_hour_window: breakItem.init_hour_window,
					end_hour_window: breakItem.end_hour_window,
				};

				// Agregar min_break_duration solo si hay valores
				if (
					breakItem.min_break_hours > 0 ||
					breakItem.min_break_minutes > 0 ||
					breakItem.min_break_seconds > 0
				) {
					processedBreak.min_break_duration = this.formatMinBreakDuration(breakItem);
				}

				return processedBreak;
			});
		},
		getCoordinates(depot) {
			const [lat, lng] = depot.split(",");
			return {lat: parseFloat(lat), lng: parseFloat(lng)};
		},
		getEndDepotCoordinates(endDepot) {
			if (!endDepot) return {};
			return this.getCoordinates(endDepot);
		},
		formatTimeWindow() {
			const timeWindow = this.resource.time_window;
			if (!timeWindow.init_date_window && !timeWindow.end_date_window) {
				timeWindow.init_date_window = "";
				timeWindow.end_date_window = "";
			} else {
				timeWindow.init_date_window = DateUtils.toDefaultDateTime(timeWindow.init_date_window, "YYYY-MM-DD");
				timeWindow.end_date_window = DateUtils.toDefaultDateTime(timeWindow.end_date_window, "YYYY-MM-DD");
			}
			if (this.isSoftTimeWindow && timeWindow.soft_time_window) {
				const soft = timeWindow.soft_time_window;
				soft.cost_per_hour_before = parseInt(soft.cost_per_hour_before);
				soft.cost_per_hour_after = parseInt(soft.cost_per_hour_after);
				soft.init_date = DateUtils.toDefaultDateTime(soft.init_date, "YYYY-MM-DD");
				soft.end_date = DateUtils.toDefaultDateTime(soft.end_date, "YYYY-MM-DD");
			}
		},
		formatDuration() {
			const {hours, minutes, seconds} = this.resource;
			return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds
				.toString()
				.padStart(2, "0")}`;
		},
		cleanupPayload(payload) {
			["skills", "capacity", "breaks"].forEach((key) => {
				if (!payload[key].length) delete payload[key];
			});

			if (Object.keys(payload.additional_info || {}).length === 0) delete payload.additional_info;
			if (Object.keys(payload.costs || {}).length === 0) delete payload.costs;
			if (!Object.keys(payload.end_depot || {}).length) delete payload.end_depot;

			if (payload.territories && (!payload.territories.items || payload.territories.items.length === 0)) {
				delete payload.territories;
			}

			if (payload.clustering === null || payload.clustering === undefined) {
				delete payload.clustering;
			}

			const timeWindow = payload.time_window || {};
			if (
				!timeWindow.init_date_window &&
				!timeWindow.end_date_window &&
				!timeWindow.init_hour_window &&
				!timeWindow.end_hour_window
			) {
				delete payload.time_window;
			}

			["profile", "max_travel_distance", "max_travel_duration", "original_identification"].forEach((key) => {
				if (!payload[key]) delete payload[key];
			});
		},
		validateErrorRegister(error) {
			if (error.data === null || error.data === undefined) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("VisitPoints.ErrorRegisterValidate.Title"),
					text: this.$t("VisitPoints.ErrorRegisterValidate.Text"),
				});
				return;
			}
			if (error.data.reason.length > 0) {
				let reason = Array.from(new Set(error.data.reason.flatMap(({absolute_path}) => absolute_path)));
				let reasonFiltered = reason
					.filter((m) => m !== "additional_info")
					.map((m) => `${m.toUpperCase()}: ${this.$t("Routing.Messages.ValidatorRequiredProperty")} `)
					.join("; ");
				this.$vs.notify({
					color: "danger",
					title: this.$t("VisitPoints.ErrorRegisterValidate.Title"),
					text: reasonFiltered,
					time: 6000,
				});
			}
		},
		getCities(departmentName) {
			Api.post("/divipola", {
				country: typeof this.selectedCountry === "object" ? this.selectedCountry.value : this.selectedCountry,
				department: departmentName ? departmentName.replaceAll(",", "") : "",
				city: "",
				world_code: "",
				only: "city_name",
				fields: ["city_name"],
			})
				.then((res) => {
					this.cities = this.generateOptionSelect(res.data, "city_name", "city_name");
				})
				.catch((e) => {
					console.error("❌ Error Getting Cities", e);
				});
		},
		getDepartments(countryName) {
			Api.post("/divipola", {
				country: countryName,
				department: "",
				city: "",
				world_code: "",
				only: "department_name",
				fields: ["department_name"],
			})
				.then((res) => {
					this.departments = this.generateOptionSelect(res.data, "department_name", "department_name");
				})
				.catch((e) => {
					console.error("❌ Error Getting Department name", e);
				});
		},
		addProperty(property) {
			let findOther = this.propertiesList.findIndex((elem) => elem.label === property.label);
			if (findOther == -1) {
				this.propertiesList.push(property);
				this.resource.additional_info[property.label] = property.value;
				this.property = {
					label: "",
					type: {
						label: "Text",
						value: "text",
					},
					value: "",
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else if (this.isUpdate) {
				this.updateProperty(property);
				this.property = {
					label: "",
					type: {
						label: "Text",
						value: "text",
					},
					value: "",
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Alert"),
					text: this.$t("ResourceModule.Messages.AddProperties.Error.Text2"),
					time: 8000,
				});
			}
		},
		addPropertyDemand(propertyDemand) {
			propertyDemand = {
				name: propertyDemand.name,
				amount: parseInt(propertyDemand.amount),
			};
			let findOther = this.propertiesListDemand.findIndex((elem) => elem.name === propertyDemand.name);
			if (findOther == -1) {
				this.propertiesListDemand.push(propertyDemand);
				this.resource.capacity = {
					name: "",
					amount: "",
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else if (this.isUpdateDemand) {
				this.updatePropertyDemand(propertyDemand);
				this.resource.capacity = {
					name: "",
					amount: "",
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Alert"),
					text: this.$t("ResourceModule.Messages.AddProperties.Error.Text2"),
					time: 8000,
				});
			}
		},
		deleteItem(data, indexItem) {
			this.propertiesList.splice(indexItem, 1);
			delete this.resource.additional_info[data.label];
		},
		editSelect(val, index) {
			this.isUpdate = true;
			this.showPromptField = true;
			this.property.label = val.label;
			this.property.value = val.value;
			this.property.type = val.type;
			this.indexUpdate = index;
		},
		updateProperty(property) {
			this.propertiesList[this.indexUpdate].label = property.label;
			this.propertiesList[this.indexUpdate].value = property.value;
			this.propertiesList[this.indexUpdate].type = property.type;
			this.resource.additional_info[property.label] = property.value;
		},
		deleteItemDemand(data, indexItem) {
			this.propertiesListDemand.splice(indexItem, 1);
		},
		editSelectDemand(val, index) {
			this.isUpdateDemand = true;
			this.showPromptDemand = true;
			this.resource.capacity.name = val.name;
			this.resource.capacity.amount = val.amount;
			this.indexUpdateDemand = index;
		},
		updatePropertyDemand(propertyDemand) {
			this.propertiesListDemand[this.indexUpdateDemand].name = propertyDemand.name;
			this.propertiesListDemand[this.indexUpdateDemand].amount = propertyDemand.amount;
		},
		showPrompt() {
			this.showPromptField = true;
			this.isUpdate = false;
			this.property = {
				label: "",
				value: "",
				type: {
					label: "Text",
					value: "text",
				},
			};
		},
		addTimeWindow() {
			this.isTimeWindow = true;
			this.isAlertTimeWindow = false;
		},
		deleteTimeWindow() {
			this.resource.time_window = {
				init_date_window: "",
				end_date_window: "",
				init_hour_window: "",
				end_hour_window: "",
			};
			this.isTimeWindow = false;
		},
		showPromptDemands() {
			this.showPromptDemand = true;
			this.isUpdateDemand = false;
			this.resource.capacity = {
				name: "",
				amount: "",
			};
		},
		showPromptSkills() {
			this.showPromptSkill = true;
			this.isUpdateSkill = false;
			this.resource.skill = "";
		},
		updatePropertySkill(propertySkill) {
			this.propertiesListSkill[this.indexUpdateSkill] = propertySkill;
		},
		deleteItemSkill(indexItem) {
			this.propertiesListSkill.splice(indexItem, 1);
		},
		addPropertySkill(propertySkill) {
			let findOther = this.propertiesListSkill.findIndex((elem) => elem === propertySkill);
			if (this.isUpdateSkill) {
				this.updatePropertySkill(propertySkill);
				this.resource.skill = "";
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else if (findOther == -1) {
				this.propertiesListSkill.push(propertySkill);
				this.resource.skill = "";
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Alert"),
					text: this.$t("ResourceModule.Messages.AddProperties.Error.Text2"),
					time: 8000,
				});
			}
		},
		validateKeyAdditionalInfo(event) {
			let regex = /^[a-zA-Z_]\w*$/;
			let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
			if (!regex.test(key)) {
				event.preventDefault();
				return false;
			}
		},
		validateAmountNumber(event) {
			let regex = /^\d+$/;
			let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
			if (!regex.test(key)) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumber(event) {
			if (this.resource.hours.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberMinutes(event) {
			if (this.resource.minutes.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberSeconds(event) {
			if (this.resource.seconds.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberPriority(event) {
			if (this.hours.length === 3) {
				event.preventDefault();
				return false;
			}
		},
		openMapInitDeposit() {
			if (
				this.resource.init_depot !== undefined &&
				this.resource.init_depot !== null &&
				this.resource.init_depot !== ""
			) {
				const divideCoordinates = this.resource.init_depot.split(",");
				const coordinates = {
					lat: divideCoordinates[0],
					lng: divideCoordinates[1],
				};
				this.mapConfig.latitude = parseFloat(coordinates.lat);
				this.mapConfig.longitude = parseFloat(coordinates.lng);
				this.showGeoAgain = false;
			} else {
				this.formatData = {
					country: "",
					department: "",
					city: "",
					address: "",
					addressOld: "",
					cx: 0,
					cy: 0,
					typeDeposit: "InitDeposit",
				};
			}
			this.formatData.typeDeposit = "InitDeposit";
			this.isDisabled = true;
			this.popupMapMounted = true;
			this.geoAlert = true;
		},
		openMapEndDeposit() {
			if (
				this.resource.end_depot !== undefined &&
				this.resource.end_depot !== null &&
				this.resource.end_depot !== ""
			) {
				const divideCoordinates = this.resource.end_depot.split(",");
				const coordinates = {
					lat: divideCoordinates[0],
					lng: divideCoordinates[1],
				};
				this.mapConfig.latitude = parseFloat(coordinates.lat);
				this.mapConfig.longitude = parseFloat(coordinates.lng);
				this.showGeoAgain = false;
			} else {
				this.formatData = {
					country: "",
					department: "",
					city: "",
					address: "",
					addressOld: "",
					cx: 0,
					cy: 0,
					typeDeposit: "EndDeposit",
				};
			}
			this.formatData.typeDeposit = "EndDeposit";
			this.isDisabled = true;
			this.popupMapMounted = true;
			this.geoAlert = true;
		},
		async callbackClick(markerEvent) {
			this.geoReverse({
				cy: markerEvent.latLng.lat(),
				cx: markerEvent.latLng.lng(),
			});
			this.map.removeMarker(this.marker);
			this.marker = this.map.addMarkerToMap(
				{cy: markerEvent.latLng.lat(), cx: markerEvent.latLng.lng()},
				{
					icon: phonesSuccess,
					draggable: true,
					infoWindow: {
						content: `
							<div class='flex items-center mt-2'>
								<span class='text-ms'>${markerEvent.latLng.lat()}, ${markerEvent.latLng.lng()}</span>
							</div>
						`,
					},
					onDragend: (coords) => {
						this.geoReverse({
							cy: coords.lat,
							cx: coords.lng,
						});
					},
				}
			);
		},
		getCoordinatesDrag(markerEvent) {
			this.geoReverse({
				cy: markerEvent.lat,
				cx: markerEvent.lng,
			});
		},
		confirmCoordinates(data) {
			if (this.formatData.typeDeposit === "InitDeposit") {
				this.resource.init_depot = `${(+data.cy).toFixed(8)},${(+data.cx).toFixed(8)}`;
			} else if (this.formatData.typeDeposit === "EndDeposit") {
				this.resource.end_depot = `${(+data.cy).toFixed(8)},${(+data.cx).toFixed(8)}`;
			}
			this.popupMapMounted = false;
		},
		closeSidebarAddResource() {
			this.$emit("closeSidebarEmit");
		},
		showPromptBreaks() {
			this.showPromptBreak = true;
			this.isUpdateBreak = false;
			this.resource.breaks = {
				init_date_window: "",
				end_date_window: "",
				init_hour_window: "",
				end_hour_window: "",
			};
			this.resource.min_break_hours = 0;
			this.resource.min_break_minutes = 0;
			this.resource.min_break_seconds = 0;
		},
		editSelectBreak(val, index) {
			this.isUpdateBreak = true;
			this.showPromptBreak = true;
			this.resource.breaks.init_date_window = moment(val.init_date_window).format();
			this.resource.breaks.end_date_window = moment(val.end_date_window).format();
			this.resource.breaks.init_hour_window = val.init_hour_window;
			this.resource.breaks.end_hour_window = val.end_hour_window;
			this.resource.min_break_hours = val.min_break_hours || 0;
			this.resource.min_break_minutes = val.min_break_minutes || 0;
			this.resource.min_break_seconds = val.min_break_seconds || 0;
			this.indexUpdateBreak = index;
		},
		updatePropertyBreak(propertyBreak) {
			this.propertiesListBreak[this.indexUpdateBreak].init_date_window = propertyBreak.init_date_window;
			this.propertiesListBreak[this.indexUpdateBreak].end_date_window = propertyBreak.end_date_window;
			this.propertiesListBreak[this.indexUpdateBreak].init_hour_window = propertyBreak.init_hour_window;
			this.propertiesListBreak[this.indexUpdateBreak].end_hour_window = propertyBreak.end_hour_window;
			this.propertiesListBreak[this.indexUpdateBreak].min_break_hours = this.resource.min_break_hours;
			this.propertiesListBreak[this.indexUpdateBreak].min_break_minutes = this.resource.min_break_minutes;
			this.propertiesListBreak[this.indexUpdateBreak].min_break_seconds = this.resource.min_break_seconds;
			this.propertiesListBreak[this.indexUpdateBreak].min_break_duration = this.formatMinBreakDuration({
				min_break_hours: this.resource.min_break_hours,
				min_break_minutes: this.resource.min_break_minutes,
				min_break_seconds: this.resource.min_break_seconds,
			});
		},
		deleteItemBreak(indexItem) {
			this.propertiesListBreak.splice(indexItem, 1);
		},
		addPropertyBreak(propertyBreak) {
			propertyBreak.init_date_window = DateUtils.toDefaultDateTime(propertyBreak.init_date_window, "YYYY-MM-DD");
			propertyBreak.end_date_window = DateUtils.toDefaultDateTime(propertyBreak.end_date_window, "YYYY-MM-DD");

			// Agregar min_break_duration en formato string
			propertyBreak.min_break_duration = this.formatMinBreakDuration({
				min_break_hours: this.resource.min_break_hours,
				min_break_minutes: this.resource.min_break_minutes,
				min_break_seconds: this.resource.min_break_seconds,
			});

			// Agregar las variables separadas
			propertyBreak.min_break_hours = this.resource.min_break_hours;
			propertyBreak.min_break_minutes = this.resource.min_break_minutes;
			propertyBreak.min_break_seconds = this.resource.min_break_seconds;

			let findOther = this.propertiesListBreak.findIndex(
				(elem) =>
					elem.init_date_window === propertyBreak.init_date_window &&
					elem.end_date_window === propertyBreak.end_date_window &&
					elem.init_hour_window === propertyBreak.init_hour_window &&
					elem.end_hour_window === propertyBreak.end_hour_window &&
					elem.min_break_hours === propertyBreak.min_break_hours &&
					elem.min_break_minutes === propertyBreak.min_break_minutes &&
					elem.min_break_seconds === propertyBreak.min_break_seconds
			);
			if (this.isUpdateBreak) {
				this.updatePropertyBreak(propertyBreak);
				this.resource.breaks = {
					init_date_window: "",
					end_date_window: "",
					init_hour_window: "",
					end_hour_window: "",
				};
				this.resource.min_break_hours = 0;
				this.resource.min_break_minutes = 0;
				this.resource.min_break_seconds = 0;
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else if (findOther == -1) {
				this.propertiesListBreak.push(propertyBreak);
				this.resource.breaks = {
					init_date_window: "",
					end_date_window: "",
					init_hour_window: "",
					end_hour_window: "",
				};
				this.resource.min_break_hours = 0;
				this.resource.min_break_minutes = 0;
				this.resource.min_break_seconds = 0;
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Alert"),
					text: this.$t("ResourceModule.Messages.AddProperties.Error.Text2"),
					time: 8000,
				});
			}
			this.$validator.pause();
			this.$nextTick(() => {
				this.$validator.errors.clear();
				this.$validator.fields.items.forEach((field) => field.reset());
				this.$validator.fields.items.forEach((field) => this.errors.remove(field));
				this.$validator.resume();
			});
		},
		removeError(errorName) {
			const index = this.errors.items.findIndex((e) => e.field === errorName);
			this.errors.items.splice(index, 1);
		},
		stringTimeToDate(stringTime) {
			let newDate = new Date();
			if (typeof stringTime === "string") {
				const [hours, minutes, seconds] = stringTime.split(":");
				newDate = new Date(1995, 11, 17, parseInt(hours), parseInt(minutes), parseInt(seconds));
			}
			return newDate;
		},
		validatorInitDate(value, args) {
			this.removeError("initDate");
			this.removeError("endDate");
			if (!value || value === "" || typeof value === "number") {
				return true;
			}
			const ih = typeof value === "string" ? new Date(value).getTime() : value.getTime();
			const eh =
				typeof this.resource.breaks.end_date_window === "string"
					? new Date(this.resource.breaks.end_date_window).getTime()
					: this.resource.breaks.end_date_window.getTime();
			return ih <= eh;
		},
		validatorEndDate(value, args) {
			this.removeError("initDate");
			this.removeError("endDate");
			if (!value || value === "" || typeof value === "number") {
				return true;
			}
			const eh = typeof value === "string" ? new Date(value).getTime() : value.getTime();
			const ih =
				typeof this.resource.breaks.init_date_window === "string"
					? new Date(this.resource.breaks.init_date_window).getTime()
					: this.resource.breaks.init_date_window.getTime();
			return eh >= ih;
		},
		validatorEndHour(value, args) {
			this.removeError("dataHourInit");
			this.removeError("dataHourEnd");
			if (this.resource.breaks.init_hour_window === "" || value === "") {
				return true;
			}
			return this.stringTimeToDate(value) > this.stringTimeToDate(this.resource.breaks.init_hour_window);
		},
		validatorInitHour(value, args) {
			this.removeError("dataHourInit");
			this.removeError("dataHourEnd");
			if (this.resource.breaks.end_hour_window === "" || value === "") {
				return true;
			}
			return this.stringTimeToDate(value) < this.stringTimeToDate(this.resource.breaks.end_hour_window);
		},
		validatorMinBreakDuration(value, args) {
			this.removeError("minBreakDuration");

			// Validar que se haya ingresado fecha y hora de inicio y fin
			if (
				!this.resource.breaks.init_date_window ||
				!this.resource.breaks.end_date_window ||
				!this.resource.breaks.init_hour_window ||
				!this.resource.breaks.end_hour_window
			) {
				return true;
			}

			// Calcular la duración total del break
			const initDate = new Date(this.resource.breaks.init_date_window);
			const endDate = new Date(this.resource.breaks.end_date_window);
			const initTime = this.stringTimeToDate(this.resource.breaks.init_hour_window);
			const endTime = this.stringTimeToDate(this.resource.breaks.end_hour_window);

			// Combinar fecha y hora
			const startDateTime = new Date(initDate);
			startDateTime.setHours(initTime.getHours(), initTime.getMinutes(), initTime.getSeconds());

			const endDateTime = new Date(endDate);
			endDateTime.setHours(endTime.getHours(), endTime.getMinutes(), endTime.getSeconds());

			// Calcular duración total en milisegundos
			const totalDurationMs = endDateTime.getTime() - startDateTime.getTime();

			// Convertir la duración mínima ingresada a milisegundos
			const minBreakDurationMs =
				(this.resource.min_break_hours * 3600 +
					this.resource.min_break_minutes * 60 +
					this.resource.min_break_seconds) *
				1000;

			// Validar que la duración mínima no exceda la duración total del break
			return minBreakDurationMs <= totalDurationMs;
		},
		formatMinBreakDuration(breakData) {
			// Si breakData es un objeto con las propiedades separadas
			if (breakData.min_break_hours !== undefined) {
				const hours = breakData.min_break_hours || 0;
				const minutes = breakData.min_break_minutes || 0;
				const seconds = breakData.min_break_seconds || 0;

				if (hours === 0 && minutes === 0 && seconds === 0) {
					return "-";
				}

				return `${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes}:${
					seconds < 10 ? "0" + seconds : seconds
				}`;
			}

			// Si breakData es un string (formato HH:MM:SS)
			if (typeof breakData === "string" && breakData !== "-") {
				return breakData;
			}

			return "-";
		},
		AddSofTimeWindow() {
			if (!this.validFormTimeWindowComputed) {
				this.isAlertTimeWindow = true;
				this.isSoftTimeWindow = false;
			} else {
				this.addSoftWindowToTimeWindow();
				this.isSoftTimeWindow = true;
				this.isAlertTimeWindow = false;
			}
		},
		deleteSoftWindow() {
			delete this.resource.time_window["soft_time_window"];
			this.isSoftTimeWindow = false;
			this.validFormTimeWindowComputed = true;
		},
		addSoftWindowToTimeWindow() {
			this.resource.time_window = {
				...this.resource.time_window,
				soft_time_window: {
					init_date: "",
					end_date: "",
					init_hour: "",
					end_hour: "",
					cost_per_hour_before: 0,
					cost_per_hour_after: 0,
				},
			};
		},
		checkZeroMaxDistanceToNeighbor() {
			if (
				!this.resource.clustering.max_distance_to_neighbor ||
				this.resource.clustering.max_distance_to_neighbor === ""
			) {
				this.resource.clustering.max_distance_to_neighbor = 25;
			}
		},
		checkZeroMaxDiameter() {
			if (!this.resource.clustering.max_diameter || this.resource.clustering.max_diameter === "") {
				this.resource.clustering.max_diameter = 100;
			}
		},
		// Método para validar los campos específicos
		validatePerCost() {
			if (this.resource && this.resource.time_window && this.resource.time_window.soft_time_window) {
				Utils.checkZero("cost_per_hour_after", this.resource.time_window.soft_time_window);
				Utils.checkZero("cost_per_hour_before", this.resource.time_window.soft_time_window);
			}
		},
		showPromptTerritories() {
			this.showPromptTerritory = true;
			this.isUpdateTerritory = false;
			this.resource.territories = {
				id: "",
				priority: 0,
			};
		},
		addPropertyTerritory(propertyTerritory) {
			propertyTerritory = {
				id: propertyTerritory.id,
				priority: parseInt(propertyTerritory.priority),
			};
			let findOther = this.propertiesListTerritory.findIndex((elem) => elem.id === propertyTerritory.id);
			if (findOther == -1) {
				this.propertiesListTerritory.push(propertyTerritory);
				this.resource.territories = {
					id: "",
					priority: 0,
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else if (this.isUpdateTerritory) {
				this.updatePropertyTerritory(propertyTerritory);
				this.resource.territories = {
					id: "",
					priority: 0,
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Alert"),
					text: this.$t("ResourceModule.Messages.AddProperties.Error.Text2"),
					time: 8000,
				});
			}
		},
		deleteItemTerritory(indexItem) {
			this.propertiesListTerritory.splice(indexItem, 1);
		},
		editSelectTerritory(val, index) {
			this.isUpdateTerritory = true;
			this.showPromptTerritory = true;
			this.resource.territories.id = val.id;
			this.resource.territories.priority = val.priority;
			this.indexUpdateTerritory = index;
		},
		updatePropertyTerritory(propertyTerritory) {
			this.propertiesListTerritory[this.indexUpdateTerritory].id = propertyTerritory.id;
			this.propertiesListTerritory[this.indexUpdateTerritory].priority = propertyTerritory.priority;
		},
		validateInputName(event) {
			let regex = /^[a-zA-Z0-9_-]+$/;
			let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
			if (!regex.test(key)) {
				event.preventDefault();
				return false;
			}
		},
	},
	watch: {
		dataCity(val) {
			if (val) {
				this.formatData.city = typeof val === "object" ? val.value : val;
			}
		},
		selectedCountry(val) {
			if (val === null || val === undefined) {
				return;
			}
			this.formatData.country = typeof val === "object" ? val.value : val;
			this.getDepartments(val.label);
		},
		selectedDepartment(val) {
			if (val === null || val === undefined) {
				return;
			}
			this.formatData.department = typeof val === "object" ? val.value : val;
			this.getCities(val.value);
		},
		hours(val) {
			if (val > 24) {
				this.hours = 24;
			}
		},
		minutes(val) {
			if (val > 59) {
				this.minutes = 59;
			}
		},
		seconds(val) {
			if (val > 59) {
				this.seconds = 59;
			}
		},
		"resource.min_break_hours"(val) {
			if (val < 0) {
				this.resource.min_break_hours = 0;
			}
		},
		"resource.min_break_minutes"(val) {
			if (val < 0) {
				this.resource.min_break_minutes = 0;
			}
			if (val > 59) {
				this.resource.min_break_minutes = 59;
			}
		},
		"resource.min_break_seconds"(val) {
			if (val < 0) {
				this.resource.min_break_seconds = 0;
			}
			if (val > 59) {
				this.resource.min_break_seconds = 59;
			}
		},
	},
	created() {
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
		if (!moduleMap.isRegistered) {
			this.$store.registerModule("moduleMap", moduleMap);
			moduleMap.isRegistered = true;
		}
		if (this.$store.state.moduleCommon.countries.length <= 0) {
			this.$store
				.dispatch("moduleCommon/getCountries")
				.then((res) => {
					if (res.data.length === 1) {
						this.selectedCountry = res.data[0]["country_name"].toUpperCase();
					}
				})
				.catch((error) => {
					console.error(error);
				});
		}
		// Create Custom Validators
		Validator.extend("validatorEndHour", this.validatorEndHour);
		Validator.extend("validatorInitHour", this.validatorInitHour);
		Validator.extend("validatorInitDate", this.validatorInitDate);
		Validator.extend("validatorEndDate", this.validatorEndDate);
		Validator.extend("validatorMinBreakDuration", this.validatorMinBreakDuration);
	},
};
